import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const greetings = [
  { text: "Hello" },             // English
  { text: "Hola" },              // Spanish
  { text: "Bonjour" },           // French
  { text: "Hallo" },             // German
  { text: "こんにちは" },        // Japanese
  { text: "안녕하세요" },        // Korean
];

const LandingScreen = ({ onComplete }) => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => {
        if (prev < greetings.length - 1) {
          return prev + 1;
        } else {
          clearInterval(interval);
          setTimeout(onComplete, 400);
          return prev;
        }
      });
    }, 500);

    return () => clearInterval(interval);
  }, [onComplete]);

  return (
    <motion.div
      className="fixed inset-0 z-[100] bg-[#050505] flex items-center justify-center cursor-default"
      initial={{ opacity: 1 }}
      exit={{ opacity: 0, transition: { duration: 0.5, ease: "easeInOut" } }}
    >
      <div className="relative w-full text-center flex justify-center items-center h-full">
        <AnimatePresence mode="wait">
          <motion.h1
            key={index}
            initial={{ opacity: 0, filter: 'blur(10px)', scale: 0.9 }}
            animate={{ opacity: 1, filter: 'blur(0px)', scale: 1 }}
            exit={{ opacity: 0, filter: 'blur(10px)', scale: 1.1 }}
            transition={{ duration: 0.2, ease: "easeOut" }}
            className="text-white leading-none font-sans"
            style={{ 
              fontSize: 'clamp(60px, 12vw, 150px)', 
              fontWeight: '600', 
              color: '#ffffff',
              fontFamily: "'Manrope', sans-serif"
            }}
          >
            {greetings[index].text}
          </motion.h1>
        </AnimatePresence>
      </div>
    </motion.div>
  );
};

export default LandingScreen;